//
//
//
//
//
//
//

export default {
    computed: {
        settings: function () {
            return this.$store.state.settings;
        }
    }
}
